import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO14 = () => {

  return (
    <StaticImage
      src="../../images/JPG-MALE-LOOK001-4.jpg"
      
      alt="Reserved avatar"
    />
  )
}

export default ImageMO14
